<template>
  <div>
    <div class="d-flex justify-space-between align-end">
      <div class="py-2 px-md-2">
        <slot name="title">
          <h1
            :class="{
              'text-h3': $vuetify.breakpoint.mdAndUp,
              'text-h4': $vuetify.breakpoint.smAndDown,
            }"
          >
            <span v-t="'Summary of preferences you\'ve entered with initial estimate'" />
          </h1>
          <span><small></small></span>
        </slot>
      </div>
      <base-btn
        :href="'http://vpkinnisvara-client-portal.local/estimate/' + $store.state.pricing.selection"
        target="_blank"
        class="ma-1"
        color="black"
        small
        :title="$t('Show pdf (opens in new tab)')"
      >
        <v-icon>mdi-file-outline</v-icon>
      </base-btn>
    </div>
    <base-card outlined>
      <EstimateItems show-description all />
      <PricingTotals />
    </base-card>
  </div>
</template>

<script>
import PricingTotals from "./totals/PricingTotals";
import EstimateItems from "./totals/EstimateItems";
export default {
  components: {
    EstimateItems,
    PricingTotals,
  },
};
</script>

<style>
</style>
